(function () {
  var STORAGE_KEY = 'complementary_product_attribution';

  function saveAttribution(element) {
    var attribution = {
      parentProductId: element.getAttribute('data-complementary-parent-product-id'),
      clickedProductId: element.getAttribute('data-complementary-clicked-product-id'),
      timestamp: Date.now()
    };

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
  }

  function getAttribution() {
    try {
      var value = sessionStorage.getItem(STORAGE_KEY);
      return value ? JSON.parse(value) : null;
    } catch (e) {
      return null;
    }
  }

  function updateCart() {
    var attribution = getAttribution();

    if (!attribution) {
      return;
    }

    fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          'Complementary Product Click': attribution.clickedProductId,
          'Complementary Parent Product': attribution.parentProductId,
          'Complementary Click Timestamp': attribution.timestamp
        }
      })
    }).catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-complementary-product="true"]');

    if (!link) {
      return;
    }

    saveAttribution(link);
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateCart();
  });

  window.addEventListener('pageshow', function () {
    updateCart();
  });
})();